<template>
  <div>
    <headBox :title="title" :showBack="fromPage != 'withdraw'"></headBox>
    <div class="settlement-detail">
      <topSearchForm @search="$refs.list.queryList(1)" @export="exportOut" class="select-form-new">
        <el-form :inline="true" class="search-box" label-position="left">
          <el-form-item label="承保时间" prop="createTime" class="items bw">
            <a-range-picker v-model="searchParams.createTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>
          <el-form-item label="产品名称" prop="policyNo" class="items sw">
            <el-input v-model="searchParams.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="" class="items sw">
            <el-input placeholder="请输入姓名/手机号" v-model="searchParams.name" class="input-with-select" clearable>
              <el-select v-model="searchParams.nameType" slot="prepend" placeholder="请选择">
                <el-option label="投保人" value="1"></el-option>
                <el-option label="被保人" value="2"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="保单号" prop="policyNo" class="items">
            <el-input v-model="searchParams.policyNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </topSearchForm>

      <div class="info-box">
        <div>
          共<span>{{ statistics.totalPolicyNum || 0 }}</span
          >单
        </div>
        <div>
          实际结算保费：<span>{{ statistics.totalPolicyFeeSum || 0 }}元</span>
        </div>
        <div v-if="showRefund()">
          退保保费：<span>{{ statistics.refundFee || 0 }}元</span>
        </div>
        <div v-if="mechanUserType == 1">
          <em v-if="activityType == 2">活动收入：</em>
          <em v-else-if="activityType == 3">活动奖金：</em>
          <em v-else>实际总收入：</em>
          <span>{{ activeName2 == 5 ? '-' : (statistics.totalIncomeTax || 0) + '元' }}</span>
        </div>
        <div v-if="mechanUserType == 2 || mechanUserType == 3">
          实际总收入：<span>{{ activeName2 == 5 ? '-' : (statistics.totalIncomeTax || 0) + '元' }}</span>
        </div>
        <div v-if="showRefund()">
          退保扣减收入：<span>{{ statistics.refundIncomeTax || 0 }}元</span>
        </div>
        <el-button v-if="showRefund()" type="text" @click="showDetail = true">查看扣减收入保单</el-button>
        <br />
        <div v-if="activeName2 == 5">
          追偿金额：<span>{{ statistics.totalIncomeTax || 0 }}元</span>
        </div>
        <div v-if="activeName2 == 5">{{ statistics.recoveryRule }}</div>
      </div>
      <salesmanSettlementList ref="list" :settlementType="activeName2" @getData="getData" :params="searchParams" :detailData="detailData"></salesmanSettlementList>

      <el-dialog title="扣减收入保单明细" :visible.sync="showDetail" width="1200px" @opened="lookRefund()">
        <salesmanSettlementList ref="modalList" :settlementType="activeName2" :params="searchParams" type="queryRefund" :detailData="detailData"></salesmanSettlementList>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import headBox from '@/components/head.vue';
import salesmanSettlementList from './component/salesmanSettlementList';
import topSearchForm from '@/components/topSearchForm';
//当前实例组件
export default {
  data: () => ({
    all: {},
    activeName: '',
    activeName2: '',
    selectList: [], //下拉选择
    showDetail: false, //扣减收入保单明细
    mechanUserType: '',
    total: 0,
    date: '', //当前结算日期
    statistics: {},
    fromPage: '',
    policyType: '', //保单类型
    listType: '', //结算类型
    activityType: '', //活动类型
    balanceDates: [], // 结算日期
    typeList: [], // 当前结算日期类型列表
    userList: [], // 保存员工数据
    userinfo: {},
    detailData: {},
    searchParams: {
      createTime: [],
      selectedLevel: '2',
      nameType: '1'
    }
  }),
  components: { salesmanSettlementList, topSearchForm, headBox },
  computed: {
    title() {
      if (this.fromPage == 'withdraw') {
        return '结算保单明细';
      } else if (sessionStorage['salesmanSettlementDetail' + this.$route.query.detailId]) {
        const data = this.detailData;
        return `${data.userName + data.balanceDate}结算保单明细`;
      } else {
        return '结算保单明细';
      }
    }
  },
  mounted() {
    if (sessionStorage['salesmanSettlementDetail' + this.$route.query.detailId]) {
      this.detailData = JSON.parse(sessionStorage['salesmanSettlementDetail' + this.$route.query.detailId]) || {};
    }
    this.userinfo = this.$tools.getLocal('userinfo');
    if (this.$route.query.detailId) {
      this.searchParams.userBalanceId = this.$route.query.detailId;
    }
    this.fromPage = this.$route.query.fromPage;
    this.date = this.$route.query.text;
    this.policyType = this.$route.query.policyType;
    this.listType = this.$route.query.type;
    this.activityType = this.$route.query.activityType;
    this.$tools.getall(data => {
      this.all = data;
    });
    this.$refs.list.queryList(1);
  },
  methods: {
    exportOut: function() {
      const params = this.$refs.list.getParams();
      if (params.balanceIds) {
        params.balanceIds = params.balanceIds.join('$');
      }
      var url = this.$config.api_root + '/master/policy/export/userPolicyIncomes?' + this.$tools.urlEncode(params);
      console.log(url);
      window.open(url);
    },
    back() {
      history.go(-1);
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data) {
      let val = data.map(item => {
        if (item.children.length == 0) {
          item.children = '';
        } else {
          this.handleDeptTree(item.children);
        }
        return item;
      });
      return val;
    },
    // 是否显示扣减相关
    showRefund() {
      if (this.mechanUserType == 1 && this.statistics.refundIncomeTax > 0) {
        return true;
      } else if (this.mechanUserType == 2 && this.statistics.refundRealIncomes > 0) {
        return true;
      }
      return false;
    },
    lookRefund() {
      this.$refs.modalList.queryList(1);
    },
    getData(data) {
      this.mechanUserType = data.mechanUserType;
      this.statistics = data.statistics;
      this.total = data.total;
    }
  }
};
</script>
<style lang="scss">
@import './settlementDetail.scss';
</style>
